class Config {
  static KOL_CAMPAIGN_ID = process.env.REACT_APP_KOL_CAMPAIGN_ID || '171916';
  static KOL_STATUS_URL = process.env.REACT_APP_KOL_STATUS_URL || 'https://waitlist.getsera.io/staging';
  static GA4_ID = process.env.REACT_APP_GA4_ID || 'G-QXB2JGEJDV';
}

export default Config;